module.exports = __webpack_public_path__ + "static/media/Minus.34bfb3ec.svg";